export const COURRIERS = [
  {
    id: "rdv",
    title: "Demande de rendez-vous en préfecture",
    desc: "Pour solliciter un rendez-vous afin de déposer votre dossier.",
    objet: "Demande de rendez-vous — dépôt d'un dossier de titre de séjour",
    body: (u) => [
      "Madame, Monsieur,",
      `Je soussigné(e) ${u.name}, demeurant ${u.address}, ${u.postal_code}, souhaite solliciter un rendez-vous auprès de vos services afin de déposer mon dossier de demande de titre de séjour.`,
      "N'ayant pas pu obtenir de créneau via la plateforme en ligne malgré plusieurs tentatives, je me permets de vous adresser cette demande par courrier. Je me tiens à votre disposition pour tout complément d'information et je peux me présenter à vos services à la date et à l'heure qui vous conviendront.",
      `Vous pouvez me joindre au ${u.phone} ou par courriel à l'adresse ${u.email}.`,
      "Dans l'attente de votre réponse, je vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations distinguées.",
    ],
  },
  {
    id: "relance",
    title: "Relance — dossier en cours d'instruction",
    desc: "Pour relancer la préfecture sur un dossier resté sans réponse.",
    objet: "Relance concernant un dossier en cours d'instruction",
    body: (u) => [
      "Madame, Monsieur,",
      `Je soussigné(e) ${u.name}, demeurant ${u.address}, ${u.postal_code}, me permets de vous relancer au sujet de mon dossier déposé auprès de vos services et actuellement en cours d'instruction (référence à préciser : numéro de dossier ou numéro étranger).`,
      "Sans nouvelle de votre part depuis plusieurs semaines, je souhaiterais connaître l'état d'avancement de mon dossier ainsi que, le cas échéant, les pièces complémentaires qu'il conviendrait de vous transmettre.",
      `Vous pouvez me joindre au ${u.phone} ou par courriel à l'adresse ${u.email}.`,
      "Je vous remercie par avance de votre retour et vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations distinguées.",
    ],
  },
  {
    id: "adresse",
    title: "Déclaration de changement d'adresse",
    desc: "Pour signaler votre nouvelle adresse à la préfecture.",
    objet: "Déclaration de changement d'adresse",
    body: (u) => [
      "Madame, Monsieur,",
      `Je soussigné(e) ${u.name}, titulaire d'un titre de séjour en cours de validité, vous informe de mon changement d'adresse.`,
      `Ma nouvelle adresse est la suivante : ${u.address}, ${u.postal_code}.`,
      "Je vous remercie de bien vouloir mettre à jour mon dossier et de m'indiquer, le cas échéant, les démarches complémentaires à effectuer ainsi que les pièces justificatives à fournir.",
      `Vous pouvez me joindre au ${u.phone} ou par courriel à l'adresse ${u.email}.`,
      "Je vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations distinguées.",
    ],
  },
  {
    id: "duplicata",
    title: "Demande de duplicata (perte ou vol)",
    desc: "Pour demander un duplicata de votre titre après perte ou vol.",
    objet: "Demande de duplicata de titre de séjour suite à perte ou vol",
    body: (u) => [
      "Madame, Monsieur,",
      `Je soussigné(e) ${u.name}, demeurant ${u.address}, ${u.postal_code}, vous informe de la perte (ou du vol) de mon titre de séjour et sollicite la délivrance d'un duplicata.`,
      "Vous trouverez ci-joint la déclaration de perte ou de vol effectuée auprès des services de police ou de gendarmerie, ainsi que les pièces justificatives nécessaires (photos d'identité, justificatif de domicile, timbre fiscal le cas échéant).",
      `Vous pouvez me joindre au ${u.phone} ou par courriel à l'adresse ${u.email}.`,
      "Je vous remercie de l'attention portée à ma demande et vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations distinguées.",
    ],
  },
];
